/**
 * Configuración de opciones para Control de Gestión
 * Lista de componentes disponibles en el módulo de Control de Gestión
 */

export const getControlGestionList = () => {
  return [
    {
      id: 'control-semanal',
      titulo: 'Control Semanal',
      descripcion: 'Visualiza el comportamiento semanal de las entregas con gráficos y estadísticas por estado.',
      path: '/control-gestion/control-semanal',
      icon: '📈',
      color: '#28ac33',
      tipo: 'semanal',
      param: 'weekly_stats',
      group: 'Principal'
    },
    // {
    //   id: 'control-diario',
    //   titulo: 'Control Diario',
    //   descripcion: 'Visualiza y gestiona el control diario de operaciones, incluyendo recepciones y estadísticas generales.',
    //   path: '/control-gestion/control-diario',
    //   icon: '📊',
    //   color: '#667eea',
    //   tipo: 'control',
    //   param: 'resumen_dates',
    //   group: 'Principal'
    // },
    {
      id: 'busqueda-guias',
      titulo: 'Búsqueda de Guías',
      descripcion: 'Busca y filtra guías específicas por diferentes criterios como número, cliente, fecha, etc.',
      path: '/control-gestion/busqueda-guias',
      icon: '🔍',
      color: '#d63c3c',
      tipo: 'busqueda',
      param: 'search_guides',
      group: 'Principal'
    },
    {
      id: 'busqueda-masiva-guias',
      titulo: 'Búsqueda Masiva de Guías',
      descripcion: 'Busca múltiples guías de manera masiva mediante códigos de barras o QR.',
      path: '/control-gestion/busqueda-masiva-guias',
      icon: '📦',
      color: '#ff9500',
      tipo: 'busqueda',
      param: 'bulk_search_guides',
      group: 'Principal'
    },
    {
      id: 'rutas-pendientes-revision',
      titulo: 'Rutas Pendientes de Revisión',
      descripcion: 'Revisa manualmente las rutas de NS que el proceso diario no pudo encontrar en DispatchTrack.',
      path: '/control-gestion/rutas-pendientes-revision',
      icon: '⚠️',
      color: '#dc3545',
      tipo: 'revision',
      param: 'ns_rutas_pendientes_revision',
      group: 'Principal'
    }
  ];
};

/**
 * Filtra las opciones de control de gestión por grupo
 * @param {string} group - Grupo a filtrar (opcional)
 * @returns {Array} Lista filtrada de opciones
 */
export const filterControlGestionByGroup = (group = null) => {
  const allOptions = getControlGestionList();

  if (!group) {
    return allOptions;
  }

  return allOptions.filter(option => option.group === group);
};

/**
 * Obtiene una opción específica por ID
 * @param {string} id - ID de la opción
 * @returns {Object|null} Opción encontrada o null
 */
export const getControlGestionOption = (id) => {
  const allOptions = getControlGestionList();
  return allOptions.find(option => option.id === id) || null;
};
